import { createContext, useContext, ReactNode } from 'react';
import { useHttpClientCore } from '@/shared';
import { ApiI9FormViewerRepository } from '@/features/i9_form_viewer/infra/repositories/ApiI9FormViewerRepository';
import { FetchI9FormSectionsUseCase } from '@/features/i9_form_viewer/application/use-cases/FetchI9FormSectionsUseCase';
import { FetchBase64ImageUseCase } from '../../application/use-cases/FetchBase64ImageUseCase';
import { FetchDocumentFilesUseCase } from '../../application/use-cases/FetchDocumentFilesUseCase';

interface I9FormViewerDIContextType {
  fetchI9FormSectionsUseCase: FetchI9FormSectionsUseCase;
  fetchBase64ImageUseCase: FetchBase64ImageUseCase;
  fetchDocumentFilesUseCase?: FetchDocumentFilesUseCase;
}

const I9FormViewerDIContext = createContext<I9FormViewerDIContextType | undefined>(undefined);

export const I9FormViewerDIProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const httpClient = useHttpClientCore();
  const repository = new ApiI9FormViewerRepository(httpClient);
  const fetchI9FormSectionsUseCase = new FetchI9FormSectionsUseCase(repository);
  const fetchBase64ImageUseCase = new FetchBase64ImageUseCase(repository);
  const fetchDocumentFilesUseCase = new FetchDocumentFilesUseCase(repository);

  return (
    <I9FormViewerDIContext.Provider value={{ fetchI9FormSectionsUseCase, fetchBase64ImageUseCase, fetchDocumentFilesUseCase }}>
      {children}
    </I9FormViewerDIContext.Provider>
  );
};

export const useI9FormViewerDI = (): I9FormViewerDIContextType => {
  const context = useContext(I9FormViewerDIContext);
  if (!context) {
    throw new Error('useI9FormViewerDI must be used within I9FormViewerDIProvider');
  }
  return context;
};
